import VTeleport from './VTeleport.vue';

export { VTeleport };
export default VTeleport;
